export default function Hero() {
  return (
    <div className="gfg-hero">
      <div className="gfg-hero-art" />
      <div className="gfg-hero-tri" />
      <div className="gfg-h-b gfg-rv">Go For Gold</div>
      <div className="gfg-orn-header gfg-rv" />
    </div>
  );
}
